/**
 * @prettier
 */
import createReducer from '../utils/createReducer';
import listingExtendedActions from '../actions/listingExtendedActions';

const initialState = {};

const actionHandlers = {
    [listingExtendedActions.FETCH_URGENCY_MESSAGE_SUCCESS](
        state,
        {
            payload: {urgencyMessage}
        }
    ) {
        return {
            ...state,
            urgencyMessage
        };
    },
    [listingExtendedActions.FETCH_BADGES_SUCCESS](
        state,
        {
            payload: {badges}
        }
    ) {
        return {
            ...state,
            badges
        };
    },
    [listingExtendedActions.FETCH_UNIT_SPACES_SUCCESS](
        state,
        {
            payload: {unitSpaces}
        }
    ) {
        return {
            ...state,
            unitSpaces
        };
    },
    [listingExtendedActions.FETCH_CONTENT_ITEMS_SUCCESS](
        state,
        {
            payload: {unitContentItems, propertyContentItems, unitMetadata}
        }
    ) {
        return {
            ...state,
            unitContentItems,
            propertyContentItems,
            unitMetadata
        };
    },
    [listingExtendedActions.FETCH_IMAGE_METADATA_SUCCESS](
        state,
        {
            payload: {imageMetadata}
        }
    ) {
        return {
            ...state,
            imageMetadata
        };
    }
};

export default createReducer(actionHandlers, initialState);
